const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const ALL = [0, 1, 2, 3, 4, 5, 6];
const WEEKDAYS = [0, 1, 2, 3, 4];
const WEEKENDS = [5, 6];
const FEES = [
  ['base', 'Base fee', 'bg-[#FF9F0A] border-[#FF9F0A] text-[#050003]', ''],
  ['rush', 'Rush hour fee', 'bg-[#FF3B30] border-[#FF3B30] text-white', '(customers see a tag with this fee\'s name on these days)'],
  ['long_distance', 'Long distance', 'bg-[#00F0FF] border-[#00F0FF] text-[#050003]', '(only for zips on the zip list; a zip with its own amount replaces this)'],
];
const num = (v) => Number(v) || 0;
const DEFAULT = { base: { amount: 0, days: ALL }, rush: { amount: 0, days: [] }, long_distance: { amount: 0, days: ALL } };
const feeOf = (fees, k) => fees?.[k] || DEFAULT[k];

export const daysLabel = (days) => {
  const d = [...(days || [])].sort().join();
  if (d === ALL.join()) return 'every day';
  if (!d) return 'no days';
  if (d === WEEKDAYS.join()) return 'Mon–Fri';
  if (d === WEEKENDS.join()) return 'Sat–Sun';
  return [...days].sort().map((i) => DAY_NAMES[i]).join(', ');
};

export const rushDays = (fees) => {
  const r = feeOf(fees, 'rush');
  return num(r.amount) > 0 && r.days?.length ? daysLabel(r.days) : '';
};

export const priceSummary = (fees) => FEES.map(([k]) => {
  const f = feeOf(fees, k);
  const name = (f.label || '').trim() || (k === 'long_distance' ? 'long distance' : k);
  if (k === 'rush' && !(num(f.amount) > 0 && f.days?.length)) return null;
  return `$${num(f.amount).toFixed(2)} ${name} ${daysLabel(f.days)}`;
}).filter(Boolean).join(' · ');

export const cleanFees = (fees) => Object.fromEntries(FEES.map(([k]) => {
  const f = feeOf(fees, k);
  return [k, { amount: num(f.amount), days: [...(f.days || [])].sort(), label: (f.label || '').trim() }];
}));

const inputCls = 'bg-[#050003] border border-[#2A0F3D] focus:border-[#39FF14] font-mono text-sm px-2 py-1 text-white outline-none rounded-none w-28';
const DEFAULT_NAMES = { base: 'Base fee', rush: 'Rush hour fee', long_distance: 'Long distance fee' };

function FeePicker({ hour, k, label, onCls, hint, fee, onChange }) {
  const toggle = (d) => onChange({ ...fee, days: fee.days.includes(d) ? fee.days.filter((x) => x !== d) : [...fee.days, d].sort() });
  const shortcut = (name, days) => (
    <button type="button" onClick={() => onChange({ ...fee, days })} className="px-2 py-1 font-mono text-[11px] border border-[#2A0F3D] text-[#A3C7A8] hover:text-white" data-testid={`slot-${hour}-${k}-days-${name.toLowerCase()}`}>{name}</button>
  );
  return (
    <div className="border border-[#2A0F3D] p-3" data-testid={`slot-${hour}-fee-${k}`}>
      <p className="font-mono text-[10px] text-[#6B8E73] uppercase mb-1.5">{fee.label?.trim() || label} · {daysLabel(fee.days)} {hint && <span className="normal-case">{hint}</span>}</p>
      <div className="flex items-center gap-1 mb-2 flex-wrap">
        <span className="text-[#A3C7A8] text-sm">$</span>
        <input type="number" inputMode="decimal" min="0" max="500" step="0.5" value={fee.amount} onChange={(e) => onChange({ ...fee, amount: e.target.value })} className={inputCls} data-testid={`slot-${hour}-${k}-amount`} />
        <input value={fee.label || ''} maxLength={30} onChange={(e) => onChange({ ...fee, label: e.target.value })} placeholder={`Name · ${DEFAULT_NAMES[k]}`}
          className={`${inputCls} w-auto flex-1 min-w-[170px] ml-1 placeholder:text-[#4B6B52]`} data-testid={`slot-${hour}-${k}-label`} />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {DAY_NAMES.map((n, d) => (
          <button key={n} type="button" onClick={() => toggle(d)} aria-pressed={fee.days.includes(d)}
            className={`w-11 py-1 font-mono text-[11px] border ${fee.days.includes(d) ? onCls : 'border-[#2A0F3D] text-[#6B8E73]'}`}
            data-testid={`slot-${hour}-${k}-day-${d}`}>{n}</button>
        ))}
        {shortcut('Weekdays', WEEKDAYS)}
        {shortcut('Weekends', WEEKENDS)}
        {shortcut('All', ALL)}
      </div>
    </div>
  );
}

export function SlotFeePickers({ hour, fees, onChange }) {
  return (
    <div className="space-y-3" data-testid={`slot-${hour}-fees`}>
      {FEES.map(([k, label, onCls, hint]) => (
        <FeePicker key={k} hour={hour} k={k} label={label} onCls={onCls} hint={hint} fee={{ ...feeOf(fees, k), days: feeOf(fees, k).days || [] }}
          onChange={(f) => onChange({ ...cleanFees(fees), [k]: f })} />
      ))}
      <p className="font-mono text-[10px] text-[#6B8E73]">Unselected day = that fee is $0 that day.</p>
    </div>
  );
}
